/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useEffect, useState } from 'react';
import { CoreContext } from '../../../context/CoreContext';
import { availableVideos } from '../../../services/mock';
import ButtonIcon from '../../ButtonIcon';

import {
  FocusTrail,
  ContentInfos,
  InfoSide,
  InfoSideTouch,
  InfoTitle,
  InfoDescription,
  ButtonPlay,
  ButtonPlayIcon,
} from './styled';

// Local VideoItem mirrors CoreContext's (non-exported) interface for the
// favourite-toggle calls below — the show details map always carries an id at
// runtime (parseVideoShow seeds it), so the cast is a structural narrowing.
interface VideoItem {
  id: number | string;
  [key: string]: unknown;
}

export default function OverlayInfos({
  playPause,
  details,
  // nextShow / prevShow accepted as null when there is no neighbour stream; the
  // parent (VideoPlayer) passes them in but the original signature didn't list
  // them, so strict mode flagged the extra props.
}: {
  playPause: () => void;
  details: Record<string, unknown>;
  nextShow?: (() => void) | null;
  prevShow?: (() => void) | null;
}) {
  const { isFavorite, toggleFavorite } = useContext(CoreContext);
  // parseVideoShow always seeds `id` on the details map before it is rendered
  // here; narrow to the CoreContext-compatible shape via a structural cast.
  const detailsAsVideo = details as unknown as VideoItem;

  return (
    <>
      <ContentInfos>
        <InfoSide>
          <InfoTitle>{details?.title}</InfoTitle>
          {/* <InfoDescription>{ details?.description }</InfoDescription>  */}
          <InfoDescription />
          <ButtonIcon
            focusKey={'button-banner-fav'}
            onPress={() => toggleFavorite(detailsAsVideo)}
            onEnterPress={() => toggleFavorite(detailsAsVideo)}
            icon={'heart'}
            spaced
          >
            {isFavorite(detailsAsVideo)
              ? `Remover dos favoritos`
              : `Adicionar aos favoritos`}
          </ButtonIcon>
        </InfoSide>
        <InfoSideTouch>
          <ButtonPlay focusKey={'play-button'} onEnterPress={playPause} onPress={playPause}>
            <ButtonPlayIcon />
          </ButtonPlay>
        </InfoSideTouch>
      </ContentInfos>
    </>
  );
}
